import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Chart } from 'chart.js/auto';
import { Subscription } from 'rxjs';
import { SettingsService } from '../../settings.service';
import { IdentityOrganisationApiClient } from 'src/app/services/api-clients/identity-organisation.api-client';
import { IdsForSettingsService } from '../../ids-for-settings.service';
import { IdentityWhitelabelApiClient } from 'src/app/services/api-clients/identity-whitelabel.api-client';
import { IdentitySystemApiClient } from 'src/app/services/api-clients/identity-system.api-client';
import { hide } from '@popperjs/core';

@Component({
  templateUrl: './signing-chart.component.html'
})
export class SigningChartComponent implements OnInit {

  protected storedData!: any[];

  AdvancedSigningColor: any = "rgb(29, 135, 253)";
  QualifiedSigningColor: any = " rgb(251, 10, 73)";
  IdinColor: any = "rgb(246, 159, 28)";
  DigipoortColor: any = "rgb(43, 211, 168)";
  SBRNexusColor: any = "rgb(43, 255, 255)";
  DeliveryColor: any = "rgb(43, 0, 0)";
  TransparantColor: any = "rgb(256, 256, 256, 0)";
  selectedOrganisationId: string = "";
  selectedWhiteLabelId: string = "";
  selectedSystemId: string = "";

  chart: Chart | undefined;
  weekno: number[] = []
  translations: any = <any>{};

  constructor(protected translateService: TranslateService, protected settingsService: SettingsService, protected idsForSettingsService: IdsForSettingsService) {
    // May not been empty.
  }

  ngOnInit(): void {
    this.getTranslations();
    this.translateService.onLangChange.subscribe(() => {
      this.getTranslations();
    });
  }

  getTranslations() {
    this.translateService.get([
      'Chart.Signings.SignatureBasedOnEseal',
      'Chart.Signings.QualifiedSigning',
      'Chart.Signings.IDIN',
      'Chart.Signings.Digipoort',
      'Chart.Signings.SBRNexus',
      'Chart.Signings.Delivery',
    ]).subscribe(translation => {
      this.translations.SignatureBasedOnEseal = translation['Chart.Signings.SignatureBasedOnEseal'];
      this.translations.QualifiedSigning = translation['Chart.Signings.QualifiedSigning'];
      this.translations.IDIN = translation['Chart.Signings.IDIN'];
      this.translations.Digipoort = translation['Chart.Signings.Digipoort'];
      this.translations.SBRNexus = translation['Chart.Signings.SBRNexus'];
      this.translations.Delivery = translation['Chart.Signings.Delivery'];
    });
  }
 CreateDataSets() {
  // Fill Array with all 0 so each week has a value needed so graph is not pushed to the left
  const signaturecountAdvanced = Array(this.weekno.length).fill(0);
  const signaturecountQualified = Array(this.weekno.length).fill(0);
  const signaturecountIdin = Array(this.weekno.length).fill(0);
  const signaturecountDigipoort = Array(this.weekno.length).fill(0);
  const signaturecountSbrNexus = Array(this.weekno.length).fill(0);
  const signaturecountDelivery = Array(this.weekno.length).fill(0);
  const placeholderArray = Array(this.weekno.length).fill(0);
  
  this.storedData.forEach(p => {
    const weekIndex = this.weekno.indexOf(p.weeknr); 
    if (weekIndex !== -1) {
      switch (p.type) {
        case "Advanced signing":
          signaturecountAdvanced[weekIndex] += p.signatureCount;
          break;
        case "Qualified signing":
          signaturecountQualified[weekIndex] += p.signatureCount;
          break;
        case "IDIN identification":
          signaturecountIdin[weekIndex] += p.signatureCount;
          break;
        case "Digipoort publication":
          signaturecountDigipoort[weekIndex] += p.signatureCount;
          break;
        case "SBR Nexus publication":
          signaturecountSbrNexus[weekIndex] += p.signatureCount;
          break;
        case "File delivery":
          signaturecountDelivery[weekIndex] += p.signatureCount;
          break;
        case "PlaceHolder":
          placeholderArray[weekIndex] += p.signatureCount;
          break;
      }
    }
  });

  
  return [{
    label: this.translations.SignatureBasedOnEseal,
    backgroundColor: this.AdvancedSigningColor,
    borderColor: this.AdvancedSigningColor,
    hoverBackgroundColor: this.AdvancedSigningColor,
    hoverBorderColor: this.AdvancedSigningColor,
    data: signaturecountAdvanced
  }, {
    label: this.translations.QualifiedSigning,
    backgroundColor: this.QualifiedSigningColor,
    borderColor: this.QualifiedSigningColor,
    hoverBackgroundColor: this.QualifiedSigningColor,
    hoverBorderColor: this.QualifiedSigningColor,
    data: signaturecountQualified
  }, {
    label: this.translations.IDIN,
    backgroundColor: this.IdinColor,
    borderColor: this.IdinColor,
    hoverBackgroundColor: this.IdinColor,
    hoverBorderColor: this.IdinColor,
    data: signaturecountIdin
  }, {
    label: this.translations.Digipoort,
    backgroundColor: this.DigipoortColor,
    borderColor: this.DigipoortColor,
    hoverBackgroundColor: this.DigipoortColor,
    hoverBorderColor: this.DigipoortColor,
    data: signaturecountDigipoort
  }, {
    label: this.translations.SBRNexus,
    backgroundColor: this.SBRNexusColor,
    borderColor: this.SBRNexusColor,
    hoverBackgroundColor: this.SBRNexusColor,
    hoverBorderColor: this.SBRNexusColor,
    data: signaturecountSbrNexus
  }, {
    label: this.translations.Delivery,
    backgroundColor: this.DeliveryColor,
    borderColor: this.DeliveryColor,
    hoverBackgroundColor: this.DeliveryColor,
    hoverBorderColor: this.DeliveryColor,
    data: signaturecountDelivery
  }, {
    data: placeholderArray,
    label: "",
    backgroundColor: this.TransparantColor,
    borderColor: this.TransparantColor,
    hoverBackgroundColor: this.TransparantColor,
    hoverBorderColor: this.TransparantColor
  }];
}
  CreateChart() {

    if (this.chart) {
      this.chart.destroy();
    }
    
    let distinctWeeks: any[] = []
    
    for(let week of this.storedData)
    {
      if(!distinctWeeks.some(list => list.weeknr === week.weeknr && list.year === week.year))
      {
        distinctWeeks.push(week);
      }
    }

    this.weekno = distinctWeeks.map(x => x.weeknr)
    this.chart = new Chart("MyChart", {
      // The type of chart we want to create
      type: 'bar',
      // The data for our dataset
      data: {
        labels: this.weekno,
        datasets: this.CreateDataSets()
      },
      //Configuration options go here
      options: {
        responsive: true,
        elements: {
          point: {
            radius: 0
          }
        },
        scales: {
          x: {
            stacked: true,
          },
          y: {
            position: 'left',
            stacked: true,
          }
        },
      }
    });
  }
}

@Component({
  selector: 'app-organisation-signing-chart',
  templateUrl: './signing-chart.component.html'
})
export class OrganisationSigningChartComponent extends SigningChartComponent {

  organisationIdSubscription: Subscription;
  constructor(public override translateService: TranslateService, 
    public override settingsService: SettingsService, 
    public override idsForSettingsService: IdsForSettingsService, 
    private organisationApiClient: IdentityOrganisationApiClient) {
    super(translateService, settingsService, idsForSettingsService);
    this.organisationIdSubscription = this.idsForSettingsService.selectedOrganisationId$
      .subscribe(organisationId => {
        // get signings
        if(this.selectedOrganisationId === "" || this.selectedOrganisationId !== organisationId) {
          this.selectedOrganisationId = organisationId;
          this.organisationApiClient.getSigningsData(organisationId).subscribe(singingData => {
            // store the data since its used in functions
            this.storedData = singingData;
            // incase of failure
            if (this.storedData === undefined) return;

            // now verify whether the chart already exists
            if (!this.chart) {
              this.CreateChart();
            }
            // now update the data of the chart
            if (this.chart) {
              this.chart.data.datasets = this.CreateDataSets()
              this.chart.update();
            }
          });
        }
      });
  }
  
  ngOnDestroy(): void {
    this.organisationIdSubscription.unsubscribe();
  }
}

@Component({
  selector: 'app-whiteLabel-signing-chart',
  templateUrl: './signing-chart.component.html'
})
export class WhiteLabelSigningChartComponent extends SigningChartComponent {

  private whiteLabelIdSubscription: Subscription;
  constructor(protected override translateService: TranslateService,
    protected override settingsService: SettingsService,
    protected override idsForSettingsService: IdsForSettingsService,
    private whiteLabelApiClient: IdentityWhitelabelApiClient) {
    super(translateService, settingsService, idsForSettingsService);
    this.whiteLabelIdSubscription = this.idsForSettingsService.selectedWhiteLabelId$.subscribe(whiteLabelId => {
      // get signings
      if (this.selectedWhiteLabelId === "" || this.selectedWhiteLabelId !== whiteLabelId) {
        this.selectedWhiteLabelId = whiteLabelId;
        if (whiteLabelId) {
          this.whiteLabelApiClient.getSigningsData(whiteLabelId).subscribe(singingData => {
            // store the data since its used in functions
            this.storedData = singingData;
            // incase of failure
            if (this.storedData === undefined) return;

            // now verify whether the chart already exists
            if (!this.chart) {
              this.CreateChart();
            }
            // now update the data of the chart
            if (this.chart) {
              this.chart.data.datasets = this.CreateDataSets()
              this.chart.update();
            }
          });
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.whiteLabelIdSubscription.unsubscribe();
  }
}

@Component({
  selector: 'app-system-signing-chart',
  templateUrl: './signing-chart.component.html'
})
export class SystemSigningChartComponent extends SigningChartComponent {

  private systemIdSubscription: Subscription;
  constructor(protected override translateService: TranslateService,
    protected override settingsService: SettingsService,
    protected override idsForSettingsService: IdsForSettingsService,
    private systemApiClient: IdentitySystemApiClient) {
    super(translateService, settingsService, idsForSettingsService);
    this.systemIdSubscription = this.idsForSettingsService.selectedSystemId$.subscribe(systemId => {
      // get signings
      if (this.selectedSystemId === "" || this.selectedSystemId !== systemId) {
        this.selectedWhiteLabelId = systemId;
        if (systemId) {
          this.systemApiClient.getSigningsData(systemId).subscribe(singingData => {
            // store the data since its used in functions
            this.storedData = singingData;
            // incase of failure
            if (this.storedData === undefined) return;

            // now verify whether the chart already exists
            if (!this.chart) {
              this.CreateChart();
            }
            // now update the data of the chart
            if (this.chart) {
              this.chart.data.datasets = this.CreateDataSets()
              this.chart.update();
            }
          });
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.systemIdSubscription.unsubscribe();
  }
}
